<template>
  <v-dialog
    :value="show"
    max-width="800"
    persistent
    @input="$emit('update:show', $event)"
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="handleClose"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        style="background-color:rgb(204 33 40);color:white !important"
        dark
      >
       <strong>Editar Usuario </strong>-{{  user.name }}
      </v-toolbar>
      <v-card-text style="padding-top: 20px;">
        <v-form ref="formEditUser">
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editedUser.NombreCompania"
                label="Compañía"
                prepend-inner-icon="mdi-sitemap"
                disabled
                readonly
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editedUser.name"
                label="Nombre"
                prepend-inner-icon="mdi-account-tie"
                clearable
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="editedUser.email"
                label="Correo"
                prepend-inner-icon="mdi-email"
                clearable
                :rules="emailRules"
                required
              />
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <v-select
                v-model="editedUser.rol"
                :items="typeRol"
                item-text="textRol"
                item-value="valueRol"
                label="Rol"
                prepend-inner-icon="mdi-account-network"
                :rules="[v => !!v || 'Este campo es requerido']"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
               align-content="center"
            justify="center"
            >
              <v-text-field
                v-model="newPassword"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Nueva Contraseña (opcional)"
                prepend-inner-icon="mdi-account-key"
                hint="Dejar vacío para mantener la contraseña actual"
                persistent-hint
                clearable
                :rules="optionalPasswordRules"
                @click:append="showPassword = !showPassword"
              />
              <password-strength :password="newPassword || ''" />
            </v-col>
          </v-row>
          <v-row v-if="msgResponse">
            <v-col cols="12">
              <v-alert
                :type="alertType"
                text
              >
                {{ msgResponse }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            v-if="progress"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col cols="6">
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Actualizando Usuario
              </v-col>
              <v-progress-linear
                color="red darken-4"
                indeterminate
                rounded
                height="6"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          style="background-color:rgb(204 33 40);color:white !important"
          @click="handleUpdate"
        >
          Actualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { getListRoles } from '@/data/listRoles'
  import PasswordStrength from '@/components/PasswordStrength'
  import { optionalPasswordRules } from '@/utils/passwordRules'
  import { emailRules } from '@/utils/emailRules'

  export default {
    name: 'EditUserModal',
    components: {
      'password-strength': PasswordStrength,
    },
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      user: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {
        optionalPasswordRules,
        emailRules,
        editedUser: {},
        msgResponse: '',
        progress: false,
        typeRol: [],
        newPassword: '',
        showPassword: false,
        alertType: 'success',
      }
    },
    async created () {
      await this.loadRoles()
    },
    watch: {
      // Cuando se abre el modal y se pasa un usuario
      user: {
        handler (newUser) {
          if (newUser && Object.keys(newUser).length > 0) {
            this.editedUser = { ...newUser }
          }
        },
        deep: true,
        immediate: true,
      },
      // Limpiar mensajes cuando se cierra el modal
      show (newVal) {
        if (!newVal) {
          this.msgResponse = ''
          this.progress = false
          this.alertType = 'success'
        }
      },
    },
    methods: {
      async loadRoles () {
        try {
          this.typeRol = await getListRoles()
        } catch (error) {
          console.error('❌ Error al cargar roles:', error)
        }
      },
      handleClose () {
        this.msgResponse = ''
        this.progress = false
        this.newPassword = ''
        this.showPassword = false
        this.alertType = 'success'
        this.$emit('close')
      },
      async handleUpdate () {
        // Validar el formulario
        if (!this.$refs.formEditUser.validate()) {
          return
        }

        this.progress = true
        this.msgResponse = ''
        this.alertType = 'success'

        try {
          // Preparar payload con todos los datos
          const payload = {
            id: this.editedUser.id,
            IdCompania: this.editedUser.IdCompania,
            name: this.editedUser.name,
            email: this.editedUser.email,
            rol: this.editedUser.rol,
          }

          // Solo agregar password si se ingresó una nueva
          if (this.newPassword && this.newPassword.trim() !== '') {
            payload.password = this.newPassword
          }

          // Una sola llamada al backend
          await this.$store.dispatch('users/updateUser', payload)

          this.progress = false
          this.alertType = 'success'
          this.msgResponse = 'Usuario actualizado exitosamente'

          setTimeout(() => {
            this.$emit('updated')
            this.handleClose()
          }, 2000)
        } catch (error) {
          this.progress = false
          this.alertType = 'error'
          this.msgResponse = error.message || 'Error al actualizar el usuario'
          console.error(error)
        }
      },
    },
  }
</script>

<style scoped>
</style>
